import { render, staticRenderFns } from "./PatientTestsComponent.vue?vue&type=template&id=8b016db4"
import script from "./PatientTestsComponent.vue?vue&type=script&lang=js"
export * from "./PatientTestsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports